// Improved share button functionality for mobile
document.addEventListener('DOMContentLoaded', function() {
  // Delay slightly to ensure we override the original functionality
  setTimeout(initializeImprovedShareButton, 100);
  
  // Also listen for resize events to handle orientation changes
  window.addEventListener('resize', function() {
    const shareButton = document.getElementById('shareButton');
    const shareDropdown = document.getElementById('shareDropdown');
    
    // If dropdown is currently active, reposition it
    if (shareDropdown && shareDropdown.classList.contains('active')) {
      repositionDropdown(shareButton, shareDropdown);
    }
  });
});

function repositionDropdown(shareButton, shareDropdown) {
  if (!shareButton || !shareDropdown) return;
  
  const buttonRect = shareButton.getBoundingClientRect();
  const isMobile = window.innerWidth < 768;
  
  if (isMobile) {
    const dropdownWidth = Math.max(shareDropdown.offsetWidth, 220);
    shareDropdown.style.top = buttonRect.top + 'px';
    shareDropdown.style.left = (buttonRect.left - 15 - dropdownWidth) + 'px';
    shareDropdown.classList.add('dropdown-left');
    shareDropdown.classList.remove('dropdown-above', 'dropdown-below');
  }
}

function initializeImprovedShareButton() {
  // First, remove any existing event listeners by cloning the button  const originalShareButton = document.getElementById('shareButton');
  if (originalShareButton) {
    const newShareButton = originalShareButton.cloneNode(true);
    originalShareButton.parentNode.replaceChild(newShareButton, originalShareButton);
  }
  
  // Now set up our improved functionality with the new button
  const shareButton = document.getElementById('shareButton');
  const shareDropdown = document.getElementById('shareDropdown');
  
  // Add a small delay to force recalculation of positioning on page load
  setTimeout(() => {
    // Force mobile detection on smaller screens
    if (window.innerWidth < 768) {
      document.body.classList.add('mobile-share-enabled');
    } else {
      document.body.classList.remove('mobile-share-enabled');
    }
  }, 200);
  
  if (shareButton && shareDropdown) {
    // Replace the existing click handler with our improved version
    shareButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (shareDropdown.classList.contains('active')) {
        closeShareDropdown();
      } else {
        openShareDropdown();
      }
    });
    
    // Functions to handle dropdown state
    function openShareDropdown() {
      shareDropdown.style.display = 'flex';
      
      // Position the dropdown according to device
      const buttonRect = shareButton.getBoundingClientRect();      const isMobile = window.innerWidth < 768;        if (isMobile) {
          // Mobile: Position in the center of the screen
          
          // Make sure dropdown is visible but starts transparent
          shareDropdown.style.opacity = '0';
          shareDropdown.style.display = 'flex';
          
          // Position in the center of the screen
          shareDropdown.style.top = '50%';
          shareDropdown.style.bottom = 'auto';
          shareDropdown.style.left = '50%';
          shareDropdown.style.transform = 'translate(-50%, -50%)';
          shareDropdown.style.width = 'calc(100% - 32px)';
          shareDropdown.style.maxWidth = '320px';
        shareDropdown.classList.remove('dropdown-above', 'dropdown-below', 'dropdown-left');
        
        // Make visible with animation
        setTimeout(() => {
          shareDropdown.style.opacity = '1';
        }, 10);
      } else {
        // Desktop: Keep existing positioning logic
        const spaceBelow = window.innerHeight - buttonRect.bottom;
        const spaceAbove = buttonRect.top;
        
        if (spaceBelow < 250 && spaceAbove > spaceBelow) {
          // Show above if there's more space above
          shareDropdown.style.top = (buttonRect.top - shareDropdown.offsetHeight - 10) + 'px';
          shareDropdown.classList.add('dropdown-above');
          shareDropdown.classList.remove('dropdown-below', 'dropdown-left');
        } else {
          // Show below by default
          shareDropdown.style.top = (buttonRect.bottom + 10) + 'px';
          shareDropdown.classList.add('dropdown-below');
          shareDropdown.classList.remove('dropdown-above', 'dropdown-left');
        }
        // Center horizontally relative to button on desktop
        shareDropdown.style.left = (buttonRect.left + (buttonRect.width / 2)) + 'px';
      }
      
      // Add active class
      shareDropdown.classList.add('active');
      
      // Only add body class on desktop to prevent screen darkening on mobile
      if (!isMobile) {
        document.body.classList.add('share-dropdown-active');
      }
      
      // Set timeout to avoid immediate closing
      setTimeout(function() {
        document.addEventListener('click', handleOutsideClick);
      }, 100);
    }
    
    function closeShareDropdown() {
      shareDropdown.style.display = 'none';
      shareDropdown.classList.remove('active');
      document.body.classList.remove('share-dropdown-active');
      document.removeEventListener('click', handleOutsideClick);
    }
    
    function handleOutsideClick(event) {
      if (!shareButton.contains(event.target) && !shareDropdown.contains(event.target)) {
        closeShareDropdown();
      }
    }
  }
}
